import { z } from 'zod';
import { defineCollection, type RecordOf } from '../collection.ts';
import { httpUrl, id, isoDate, longText, requiredText, shortText, tagList } from '../fields.ts';

export const MEAL_SLOTS = ['breakfast', 'lunch', 'dinner', 'snack'] as const;
export type MealSlot = (typeof MEAL_SLOTS)[number];

export const mealEntries = defineCollection({
  name: 'meal_entries',
  module: 'meals',
  label: { one: 'meal', other: 'meals' },
  schema: z.object({
    date: isoDate,
    slot: z.enum(MEAL_SLOTS),
    title: requiredText(200),
    recipeId: id.nullable().default(null),
    notes: shortText(2_000).default(''),
  }),
  defaultAudience: 'family',
  childAccess: 'read',
  editPolicy: 'collaborative',
  immutableFields: [],
  manualMergeFields: [],
});

export const recipes = defineCollection({
  name: 'recipes',
  module: 'meals',
  label: { one: 'recipe', other: 'recipes' },
  schema: z.object({
    name: requiredText(200),
    ingredients: z.array(z.string().trim().min(1).max(200)).max(100).default([]),
    instructions: longText(20_000).default(''),
    link: httpUrl.default(''),
    servings: shortText(20).default(''),
    tags: tagList.default([]),
  }),
  defaultAudience: 'family',
  childAccess: 'read',
  editPolicy: 'collaborative',
  immutableFields: [],
  manualMergeFields: ['instructions'],
});

export type MealEntry = RecordOf<typeof mealEntries>;
export type Recipe = RecordOf<typeof recipes>;
